import { useApps } from '@auth/useApps'
import { useDialog } from '@globals/dialog/useDialogStore'
import { TenantMemberOrTeamDisplayData } from '@kudos/http-client'
import { Selectable } from '@shared/filters/selections'
import useUpgradeLicense from '@shared/licensing/useUpgradeLicense'
import { AppPermission } from '@shared/permissions'
import { v4 as uuidv4 } from 'uuid'
export enum RecognitionModalViews {
  SendRecognition,
  DraftAndInProgressRecognitions,
}

export type RecognitionDialogData = {
  view: RecognitionModalViews
  recognitionId?: string
  recipients?: TenantMemberOrTeamDisplayData[]
  qualities?: Selectable[]
  refinementSessionId?: string
  delegatorId?: string
  delegatorFirstName?: string
  delegatorLastName?: string
}

export const RECOGNITION_MODAL_KEY = 'recognitionModalKey'

const useRecognitionModal = () => {
  const [hasAppPermissions] = useApps()
  const { showUpgradeDialog } = useUpgradeLicense()
  const hasUpgradePermission = hasAppPermissions(
    'recognitionApp',
    AppPermission.RecognitionAppUpgradeLicense,
  )
  const {
    setData,
    openDialog: open,
    closeDialog: close,
    isOpen,
    dialogData,
  } = useDialog<RecognitionDialogData>(RECOGNITION_MODAL_KEY)

  return {
    setView: (data: RecognitionDialogData) => {
      setData({
        ...data,
        refinementSessionId: dialogData?.refinementSessionId,
      })
    },
    openDialog: (data: RecognitionDialogData) => {
      if (hasUpgradePermission) {
        showUpgradeDialog()
      } else
        open({
          ...data,
          refinementSessionId: uuidv4(),
        })
    },
    closeDialog: () => {
      close()
    },
    isOpen,
    dialogData,
  }
}

export default useRecognitionModal
